import { render, staticRenderFns } from "./recruit-apply.vue?vue&type=template&id=a0bf1b1a&scoped=true"
import script from "./recruit-apply.vue?vue&type=script&lang=js"
export * from "./recruit-apply.vue?vue&type=script&lang=js"
import style0 from "./recruit-apply.vue?vue&type=style&index=0&id=a0bf1b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bf1b1a",
  null
  
)

export default component.exports